export default "__VITE_ASSET__C$lLL9bN__"